export const getVersionData = (state) => state.VersionData.Data;
